import { render, staticRenderFns } from "./MnEdit.vue?vue&type=template&id=855f04e2&scoped=true"
import script from "./MnEdit.vue?vue&type=script&lang=js"
export * from "./MnEdit.vue?vue&type=script&lang=js"
import style0 from "./MnEdit.vue?vue&type=style&index=0&id=855f04e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855f04e2",
  null
  
)

export default component.exports